import { type APIs } from '../../core/api';
import { usePlatform } from '../PlatformContext';

export const useApi = (): APIs => usePlatform().apis;
